import CT from '@marketplace-ai/tags';
import { WizardSteps } from '~/components/Wizard/WizardSteps';
import { wizardPageDetails } from './constants';
import { WizardProps } from './types';

const TAGS = CT.academics.training.wizard;

export const TrainingWizard = (props: WizardProps) => {
  const { currentPage } = props;
  const steps = wizardPageDetails.map((wizardPageDetail) => ({ label: wizardPageDetail.header }));
  const wizardPageDetail = wizardPageDetails[currentPage];
  const Page = wizardPageDetail.form;

  return (
    <div className="max-w-full">
      <WizardSteps currentStep={currentPage} steps={steps} />
      <h1
        data-cy={`${TAGS.form}-${wizardPageDetail.header.toLowerCase()}-step`}
        className="mb-4 text-left sub-heading-sb text-grey-100"
      >
        {wizardPageDetail.title}
      </h1>
      <div className="flex flex-col gap-5">
        <Page {...props} />
      </div>
    </div>
  );
};
